import React from 'react';
import './StepWizard.css';

const StepWizard = ({
  steps,
  currentStep,
  onStepChange,
  onComplete,
  onCancel,
  isSubmitting = false,
  submitLabel = 'Създай',
  cancelLabel = 'Отказ',
  nextLabel = 'Напред',
  prevLabel = 'Назад',
  children,
}) => {
  const totalSteps = steps.length;
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps - 1;

  const handleNext = () => {
    if (isLastStep) {
      onComplete?.();
    } else {
      onStepChange(currentStep + 1);
    }
  };

  const handlePrev = () => {
    if (!isFirstStep) {
      onStepChange(currentStep - 1);
    }
  };

  const handleStepClick = (stepIndex) => {
    // Only allow going back to previous steps
    if (stepIndex < currentStep) {
      onStepChange(stepIndex);
    }
  };

  return (
    <div className="step-wizard">
      {/* Progress indicator */}
      <div className="wizard-progress">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`wizard-step ${index === currentStep ? 'active' : ''} ${
              index < currentStep ? 'completed' : ''
            }`}
            onClick={() => handleStepClick(index)}
          >
            <div className="step-number">
              {index < currentStep ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              ) : (
                index + 1
              )}
            </div>
            <div className="step-info">
              <span className="step-label">{step.label}</span>
              {step.description && <span className="step-description">{step.description}</span>}
            </div>
            {index < totalSteps - 1 && <div className="step-connector" />}
          </div>
        ))}
      </div>

      {/* Step content */}
      <div className="wizard-content">
        <div className="wizard-step-header">
          <h2>{steps[currentStep]?.title || steps[currentStep]?.label}</h2>
          {steps[currentStep]?.subtitle && (
            <p className="wizard-step-subtitle">{steps[currentStep].subtitle}</p>
          )}
        </div>
        <div className="wizard-step-body">{children}</div>
      </div>

      {/* Navigation buttons */}
      <div className="wizard-actions">
        <div className="wizard-actions-left">
          {onCancel && (
            <button
              type="button"
              className="btn-text"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              {cancelLabel}
            </button>
          )}
        </div>
        <div className="wizard-actions-right">
          {!isFirstStep && (
            <button
              type="button"
              className="btn-secondary"
              onClick={handlePrev}
              disabled={isSubmitting}
            >
              {prevLabel}
            </button>
          )}
          <button
            type="button"
            className={isLastStep ? 'btn-primary' : 'btn-primary'}
            onClick={handleNext}
            disabled={isSubmitting || steps[currentStep]?.isInvalid}
          >
            {isSubmitting ? (
              <span className="loading-spinner" />
            ) : isLastStep ? (
              submitLabel
            ) : (
              nextLabel
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepWizard;
